import React from 'react';
import { createPortal } from 'react-dom';
import InsufficientCredits from '../credit-plans/InsufficientCredits';
import type { ProductCreditCheck } from './lib/product-credits';

/**
 * Renders InsufficientCredits via a portal so it escapes the .import-hub
 * scoped-CSS subtree (which strips borders and neutralizes button
 * backgrounds for every element under it).
 */
export const ProductCreditsModal: React.FC<{
  check: ProductCreditCheck | null;
  teamId: string;
  onClose: () => void;
}> = ({ check, teamId, onClose }) => {
  if (!check || typeof document === 'undefined') return null;

  return createPortal(
    <InsufficientCredits
      isOpen
      type='product'
      teamId={teamId}
      requiredCredits={check.required}
      usedCredits={check.used}
      availableCredits={check.total}
      remainingCredits={check.remaining}
      onClose={onClose}
    />,
    document.body,
  );
};

export default ProductCreditsModal;
